module.exports = __webpack_public_path__ + "static/hero-background-9d63fb8969a6236e9cb0259dce8c5d2f.jpg";